export const ActionTypes = {
  GET_INITIAL_EVENTS_REQUEST: '[NEXT HORSE RACING] GET INITIAL EVENTS REQUEST',
  GET_INITIAL_EVENTS_SUCCESS: '[NEXT HORSE RACING] GET INITIAL EVENTS SUCCESS',
  GET_INITIAL_EVENTS_FAILURE: '[NEXT HORSE RACING] GET INITIAL EVENTS FAILURE',
  REMOVE_EVENT: '[NEXT HORSE RACING] REMOVE EVENT',
};

export class Actions {
  /**
   * Get all initial events request
   * @return {{type: string}}
   */
  static getInitialEventsRequest() {
    return {
      type: ActionTypes.GET_INITIAL_EVENTS_REQUEST
    };
  }

  /**
   * Get all initial events success
   * @param {Object[]} allEvents - array of events ordered by startTime
   * @return {{payload: {allEvents: Object[]}, type: string}}
   */
  static getInitialEventsSuccess(allEvents) {
    return {
      type: ActionTypes.GET_INITIAL_EVENTS_SUCCESS,
      payload: allEvents

    };
  }

  /**
   * Get all initial events failure
   * @return {{type: string}}
   */
  static getInitialEventsFailure(err) {
    return {
      type: ActionTypes.GET_INITIAL_EVENTS_FAILURE,
      payload: err
    };
  }

  /**
   * Remove event from allEvent array.
   * @return {{type: string}}
   */
  static removeEvent(eventId) {
    return {
      type: ActionTypes.REMOVE_EVENT,
      payload: eventId
    };
  }
}
